import React from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import { Delete as DeleteIcon, HideSource as RemovedIcon } from '@mui/icons-material';
import PropertyCard from './PropertyCard';

const Listing = ({ properties, onPropertyClick, showEditButton = false }) => {
  if (!properties || properties.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 6, width: '100%' }}>
        <Typography variant="h6" sx={{ color: '#666', fontWeight: 600 }}>
          Brak mieszkań o podanych kryteriach
        </Typography>
        <Typography variant="body2" sx={{ color: '#999', mt: 1 }}>
          Zmień ustawienia filtra
        </Typography>
      </Box>
    );
  }
  
  return (
    <div style={{ width: '100%' }}>
      {properties.map((property) => (
        <div key={property.id} style={{ marginBottom: 24, position: 'relative' }}>
          {/* Placeholder dla usuniętego ogłoszenia */}
          {property._isDeleted ? (
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2.5,
                borderRadius: 2,
                backgroundColor: '#F5F5F5',
                border: '1px dashed #CCC',
                opacity: 0.7,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <RemovedIcon sx={{ color: '#999', fontSize: 28 }} />
                <Box>
                  <Typography variant="body1" sx={{ color: '#888', fontWeight: 500 }}>
                    Ogłoszenie zostało usunięte
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#AAA' }}>
                    Właściciel usunął to ogłoszenie
                  </Typography>
                </Box>
              </Box>
              {property.onRemoveFavorite && (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    property.onRemoveFavorite(property.id);
                  }}
                  sx={{
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    color: '#999',
                    '&:hover': {
                      backgroundColor: 'rgba(0,0,0,0.1)',
                      color: '#d32f2f'
                    },
                    width: 36,
                    height: 36
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            </Paper>
          ) : (
            <PropertyCard
              title={property.title}
              city={property.city || (property.address ? property.address.split(',')[0] : (property.location ? property.location.split(',')[0] : ''))}
              street={property.street || (property.address ? property.address.split(',')[1] : (property.location ? property.location.split(',')[1] : ''))}
              district={property.district || property.dzielnica || ''}
              location={property.location || property.address}
              price={property.priceString || property.price}
              type={property.type}
              image_url={Array.isArray(property.image_url) ? property.image_url[0] : property.image_url}
              area={property.area}
              onClick={() => onPropertyClick && onPropertyClick(property)}
              rooms={property.rooms}
              floor={property.floor}
              total_floors={property.total_floors}
              rent={property.rent}
              wynajem={property.wynajem}
              created_at={property.created_at}
              renderBottomAction={property.renderBottomAction}
              renderAction={property.onRemoveFavorite ? () => (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    property.onRemoveFavorite(property.id);
                  }}
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#d32f2f',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      color: '#b71c1c'
                    },
                    width: 36,
                    height: 36
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              ) : property.renderAction}
              showEditButton={showEditButton}
              is_premium={property.is_premium}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Listing;
